import { registerPlugin } from '@capacitor/core';

import type { OrlikfyScreenshotDetectPlugin } from './definitions';

const OrlikfyScreenshotDetect = registerPlugin<OrlikfyScreenshotDetectPlugin>('OrlikfyScreenshotDetect', {
  web: () => import('./web').then((m) => new m.OrlikfyScreenshotDetectWeb())
});

export * from './definitions';
export { OrlikfyScreenshotDetect };
